<template>
  <div class="layout">
    <nav class="sidebar">
      <router-link to="/" class="logo">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 77.1 135.9" fill="currentColor">
          <g>
            <path d="M-54.8,153.6v5.2h-2.3v-2.9h-3.3v20.4h3.2v-5h2.3v7.3h-7.8v-25h7.9Z"/>
            <path d="M-49.3,178.7v-25.1h7.9v25.1h-7.9ZM-47,176.4h3.2v-20.4h-3.2v20.4Z"/>
            <path d="M-35.8,178.7v-25.1h7.9v5.2h-2.3v-2.9h-3.2v7.3h2.9v2.3h-2.9v13.1h-2.4Z"/>
            <path d="M-22.2,178.7v-25.1h7.9v5.2h-2.4v-2.9h-3.2v7.3h2.9v2.3h-2.9v13.1h-2.3Z"/>
            <path d="M-.8,153.6v5.2h-2.3v-2.9h-3.1v7.3h2.9v2.3h-2.9v10.7h3.2v-5H-.7v7.3h-8v-24.9H-.8Z"/>
            <path d="M12.7,153.6v5.2h-2.3v-2.9h-3.1v7.3h2.9v2.3h-2.9v10.7h3.2v-5h2.3v7.3h-7.9v-24.9h7.8Z"/>
            <path d="M36.2,153.6v5.2h-2.3v-2.9h-3.2v5.3l5.5,5.5v12h-7.9v-7.3h2.3v5h3.2v-8.7l-5.5-5.5v-8.6"/>
            <path d="M44.7,178.7v-13.7l-2.8-2.8v-8.6h2.3v7.6l1.6,1.6,1.6-1.6v-7.6h2.3v8.6l-2.7,2.7v13.8h-2.3Z"/>
            <path d="M61,178.7v-11l-3.2-3.2v14.2h-2.3v-25.1h2.3v7.6l3.2,3.2v-10.8h2.3v25.1h-2.3Z"/>
            <path d="M77,153.6v21.6l-3.5,3.5h-4.4v-25.1h7.9ZM71.5,176.4h1l2.1-2.1v-18.3h-3.2v20.4h0Z"/>
            <path d="M86.4,153.6v2.3h-1v20.4h1v2.3h-4.4v-2.3h1v-20.4h-1v-2.3h4.4Z"/>
            <path d="M99.6,153.6v5.2h-2.3v-2.9h-3.2v20.4h3.2v-5h2.3v7.3h-7.9v-25h7.9Z"/>
            <path d="M110.3,178.7v-13.1h-3.2v13.1h-2.3v-21.6l3.5-3.5h4.4v25.1h-2.4ZM110.3,156h-1l-2.1,2.1v5.2h3.2v-7.3h0Z"/>
            <path d="M121.1,178.7v-22.8h-1.3v2.9h-2.2v-5.2h9.2v5.2h-2.2v-2.9h-1.3v22.8h-2.2Z"/>
            <path d="M139.8,153.6v5.2h-2.3v-2.9h-3.2v7.3h2.9v2.3h-2.9v10.7h3.2v-5h2.3v7.3h-7.9v-24.9h7.9Z"/>
          </g>
          <g>
            <path d="M20.8,78.5l17,9.8c.5.3,1.1.3,1.6,0l17-9.8c1.1-.6,1.1-2.2,0-2.8l-7.8-4.5c-.5-.3-1.1-.3-1.6,0l-7.5,4.4c-.5.3-1.1.3-1.6,0l-7.5-4.4c-.5-.3-1.1-.3-1.6,0l-7.8,4.5c-1.3.6-1.3,2.1-.2,2.8Z"/>
            <path d="M11.9,27.9l25.9-14.9c.5-.3,1.1-.3,1.6,0l23.4,13.5c.5.3,1.1.3,1.6,0l7.8-4.5c1.1-.6,1.1-2.2,0-2.8L39.3.2c-.5-.3-1.1-.3-1.6,0L.8,21.5c-.5.3-.8.8-.8,1.4v38c0,1.3,1.4,2,2.4,1.4l7.8-4.5c.5-.3.8-.8.8-1.4v-27.1c0-.6.4-1.1.9-1.4Z"/>
            <path d="M77.1,70.1v42.8c0,.6-.3,1.1-.8,1.4l-36.9,21.3c-.5.3-1.1.3-1.6,0L4.9,116.6c-1.1-.6-1.1-2.2,0-2.8l7.8-4.5c.5-.3,1.1-.3,1.6,0l23.4,13.5c.5.3,1.1.3,1.6,0l25.9-14.9c.5-.3.8-.8.8-1.4v-30.8h0l-2.4-1.4-11.1-6.4-2.4-1.4-2.4-1.4-8.4-4.8c-.5-.3-1.1-.3-1.6,0l-8.4,4.8-2.4,1.4-2.4,1.4-10.2,5.9c-.5.3-1.1.3-1.6,0l-7.8-4.5c-1.1-.6-1.1-2.2,0-2.8l8.6-5,2.4-1.4,2.4-1.4,19.4-11.2c.5-.3,1.1-.3,1.6,0l19.4,11.2,2.4,1.4,2.4,1.4,7.3,4.2,5.5,3.2c.2,0,.8.3.8,1.2Z"/>
          </g>
          <g>
            <path d="M-57.5,187.6v1q0,.1-.1.1h-.9q-.1,0-.1-.1v-.4c0-.2-.1-.4-.4-.4h-2.7c-.2,0-.4.1-.4.4v3.5c0,.2,0,.4.4.4h2.7c.2,0,.4-.1.4-.4v-.4q0-.1.1-.1h.9q.1,0,.1.1v1c0,.6-.3.9-.9.9h-3.9c-.6,0-.9-.3-.9-.9v-4.7c0-.6.3-.9.9-.9h3.9c.6,0,.9.3.9.9Z"/>
            <path d="M-55.9,192.3v-4.7c0-.6.3-.9.9-.9h3.9c.6,0,.9.3.9.9v4.7c0,.6-.3.9-.9.9h-3.9c-.6,0-.9-.3-.9-.9ZM-54.4,192.1h2.7c.2,0,.4-.1.4-.4v-3.7c0-.2-.1-.4-.4-.4h-2.7c-.2,0-.4.1-.4.4v3.7c0,.3.2.4.4.4Z"/>
            <path d="M-48.6,186.8q0-.1.1-.1h5.1q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-4v1.6h3.2q.1,0,.1.1v.8q0,.1-.1.1h-3.2v2.5q0,.1-.1.1h-.9q-.1,0-.1-.1v-6h-.1Z"/>
            <path d="M-41.6,186.8q0-.1.1-.1h5.1q0,0,0,.1v.8c0,.1,0,.1,0,.1h-4v1.6h3.2q0,0,0,.1v.8q0,.1,0,.1h-3.2v2.5q0,.1-.1.1h-.9q-.1,0-.1-.1v-6h0Z"/>
            <path d="M-34.7,193v-6.1q0-.1,0-.1h5.1q0,0,0,.1v.8c0,.1,0,.1,0,.1h-4v1.6h3.2q0,0,0,.1v.8q0,.1,0,.1h-3.2v1.6h4q0,0,0,.1v.8c0,.1,0,.1,0,.1h-5.1c0,0,0,0,0,0Z"/>
            <path d="M-27.8,193v-6.1q0-.1,0-.1h5.1q0,0,0,.1v.8c0,.1,0,.1,0,.1h-4v1.6h3.2q0,0,0,.1v.8q0,.1,0,.1h-3.2v1.6h4q0,0,0,.1v.8c0,.1,0,.1,0,.1h-5.1c0,0,0,0,0,0Z"/>
            <path d="M-18.1,193v-6.1q0-.1,0-.1h5.1q0,0,0,.1v.8c0,.1,0,.1,0,.1h-4v1.6h3.2q0,0,0,.1v.8q0,.1,0,.1h-3.2v1.6h4q0,0,0,.1v.8c0,.1,0,.1,0,.1h-5.1c0,0,0,0,0,0Z"/>
            <path d="M-5.4,187.5v4.7c0,.6-.3.9-.9.9h-1.4c.2.2.3.2.3.3l.2.3c0,.1,0,.2,0,.2h-.9q0,0-.2-.1l-.3-.7h-1.6c-.6,0-.9-.3-.9-.9v-4.7c0-.6.3-.9.9-.9h3.9c.6,0,1,.4,1,.9ZM-6.6,188.1c0-.2,0-.4-.4-.4h-2.7c-.2,0-.4.1-.4.4v3.7c0,.2,0,.4.4.4h2.7c.2,0,.4-.1.4-.4v-3.7Z"/>
            <path d="M1.9,186.8v5.3c0,.6-.3.9-.9.9h-3.9c-.6,0-.9-.3-.9-.9v-5.3q0-.1,0-.1h.9q0,0,0,.1v4.8c0,.2,0,.4.4.4H.4c.2,0,.4-.1.4-.4v-4.8q0-.1,0-.1h.9c.1,0,.1.1.1.1Z"/>
            <path d="M3.7,186.7h.9q0,0,0,.1v6.1q0,.1,0,.1h-.9q0,0,0-.1v-6.1s0-.1,0-.1Z"/>
            <path d="M6.4,186.8q0-.1,0-.1h4.7c.6,0,.9.3.9.9v2.9c0,.6-.3.9-.9.9h-3.7v1.6q0,.1,0,.1h-.9q0,0,0-.1v-6.2ZM10.6,190.4c.2,0,.4-.1.4-.4v-1.8c0-.2,0-.4-.4-.4h-3v2.6h3Z"/>
            <path d="M19.1,186.8c0-.1,0-.1,0-.1h.9q0,0,0,.1v6.1q0,.1,0,.1h-.9q0,0,0-.1v-4.3l-2.1,2.6-2.1-2.6v4.3q0,.1,0,.1h-.9q0,0,0-.1v-6.1q0-.1,0-.1h.9q0,0,0,.1l2.1,2.7,2.1-2.7Z"/>
            <path d="M21.9,193v-6.1q0-.1,0-.1h5.1q0,0,0,.1v.8c0,.1,0,.1,0,.1h-4v1.6h3.2q0,0,0,.1v.8q0,.1,0,.1h-3.2v1.6h4q0,0,0,.1v.8c0,.1,0,.1,0,.1h-5.1c0,0,0,0,0,0Z"/>
            <path d="M28.8,186.8q0-.1,0-.1h.9q0,0,0,.1l3.8,4.4v-4.4q0-.1,0-.1h.9q0,0,0,.1v6.1q0,.1,0,.1h-.8q0,0-.2-.1l-3.8-4.4v4.4q0,.1,0,.1h-.9q0,0,0-.1v-6.1Z"/>
            <path d="M36.3,186.8q0-.1,0-.1h5.3q0,0,0,.1v.9q0,.1,0,.1h-2.1v5.1q0,.1,0,.1h-.9c0,0,0-.1,0-.1v-5.1h-2.1q0,0,0-.1s0-.9,0-.9Z"/>
            <path d="M45.9,193v-.8q0-.1,0-.1h3.6c.2,0,.4-.1.4-.4v-.8c0-.2,0-.4-.4-.4h-2.8c-.6,0-.9-.3-.9-.9v-2c0-.6.3-.9.9-.9h4.3q0,0,0,.1v.8q0,.1,0,.1h-3.6c-.2,0-.4.1-.4.4v.9c0,.2,0,.4.4.4h2.8c.6,0,.9.3.9.9v1.8c0,.6-.3.9-.9.9h-4.3c0,.1,0,0,0,0Z"/>
            <path d="M52.8,193v-5.4c0-.6.4-.9.9-.9h3.9c.6,0,.9.3.9.9v5.3q0,.1-.1.1h-.9q0,0,0-.1v-2.3h-3.4v2.4q0,.1,0,.1h-.9c0,0-.2-.1-.2-.1ZM57.4,189.6v-1.4c0-.2-.2-.4-.4-.4h-2.6c-.2,0-.4.1-.4.4v1.4h3.4Z"/>
            <path d="M61.3,186.7q.1,0,.1.1v5.2h3.5q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-4.6q-.1,0-.1-.1v-6.1c0-.1.1-.1.1-.1h1Z"/>
            <path d="M66.4,193v-6.1q0-.1.1-.1h5.1q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-4v1.6h3.2q.1,0,.1.1v.8q0,.1-.1.1h-3.2v1.6h4q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-5.1c-.1,0-.1,0-.1,0Z"/>
            <path d="M73.3,193v-.8q0-.1.1-.1h3.6c.2,0,.4-.1.4-.4v-.8c0-.2-.1-.4-.4-.4h-2.8c-.6,0-.9-.3-.9-.9v-2c0-.6.3-.9.9-.9h4.3q.1,0,.1.1v.8q0,.1-.1.1h-3.6c-.2,0-.4.1-.4.4v.9c0,.2.1.4.4.4h2.8c.6,0,.9.3.9.9v1.8c0,.6-.3.9-.9.9h-4.3c-.1.1-.1,0-.1,0Z"/>
            <path d="M95.8,193v-.8q0-.1.1-.1h3.6c.2,0,.4-.1.4-.4v-.8c0-.2-.1-.4-.4-.4h-2.8c-.6,0-.9-.3-.9-.9v-2c0-.6.3-.9.9-.9h4.3q.1,0,.1.1v.8q0,.1-.1.1h-3.6c-.2,0-.4.1-.4.4v.9c0,.2.1.4.4.4h2.8c.6,0,.9.3.9.9v1.8c0,.6-.3.9-.9.9h-4.3c0,.1-.1,0-.1,0Z"/>
            <path d="M102.7,193v-6.1q0-.1.1-.1h5.1q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-4v1.6h3.2q.1,0,.1.1v.8q0,.1-.1.1h-3.2v1.6h4q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-5.1c0,0-.1,0-.1,0Z"/>
            <path d="M109.7,193v-6.1q0-.1.1-.1h4.7c.6,0,.9.3.9.9v1.5c0,.6-.3.9-.9.9h0c.6.1.9.4.9,1v1.9q0,.1-.1.1h-.9q-.1,0-.1-.1v-1.9c0-.3-.2-.5-.5-.5h-2.9v2.4q0,.1-.1.1h-.9c-.2,0-.2,0-.2,0ZM113.8,189.6c.3,0,.5-.2.5-.5v-.9c0-.2-.1-.4-.4-.4h-3v1.8h2.9Z"/>
            <path d="M121.6,189v-2.2q0-.1.1-.1h.9q.1,0,.1.1v2.6q0,.1-.1.1l-2.4,3.4c0,.1-.1.1-.1.1h-.6q-.1,0-.1-.1l-2.4-3.4h-.1v-2.7q0-.1.1-.1h.9q.1,0,.1.1v2.2l1.7,2.7,1.9-2.7Z"/>
            <path d="M124.5,186.7h.9q.1,0,.1.1v6.1q0,.1-.1.1h-.9q-.1,0-.1-.1v-6.1h.1Z"/>
            <path d="M133,187.6v1q0,.1-.1.1h-.9q-.1,0-.1-.1v-.4c0-.2-.1-.4-.4-.4h-2.7c-.2,0-.4.1-.4.4v3.5c0,.2.1.4.4.4h2.7c.2,0,.4-.1.4-.4v-.4q0-.1.1-.1h.9q.1,0,.1.1v1c0,.6-.3.9-.9.9h-3.9c-.6,0-.9-.3-.9-.9v-4.7c0-.6.3-.9.9-.9h3.9c.6,0,.9.3.9.9Z"/>
            <path d="M134.5,193v-6.1q0-.1.1-.1h5.1q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-4v1.6h3.2q.1,0,.1.1v.8q0,.1-.1.1h-3.2v1.6h4q.1,0,.1.1v.8c0,.1-.1.1-.1.1h-5.1c-.1,0-.1,0-.1,0Z"/>
            <path d="M84.1,190.8c0-.5.3-.8.7-.8h0c-.4-.1-.7-.4-.7-.9v-1.5c0-.6.3-.9.9-.9h3.9c.6,0,.9.3.9.9v.9h-1.2v-.4c0-.2-.1-.4-.4-.4h-2.7c-.2,0-.4.1-.4.4v.8c0,.3.2.5.5.5h4.9q.1,0,.1.1v.8q0,.1-.1.1h-.8v1.7c0,.6-.3.9-.9.9h-3.9c-.6,0-.9-.3-.9-.9v-1.3h0ZM85.7,192h2.7c.2,0,.4-.1.4-.4v-1.2h-2.9c-.3,0-.5.2-.5.5v.8c0,.2.1.3.3.3Z"/>
          </g>
        </svg>
      </router-link>
      <router-link to="/">Home</router-link>
      <router-link to="/about">About</router-link>
      <router-link to="/services">Services</router-link>
      <!-- <router-link to="/syndi-cart">Syndi-cart™</router-link> -->
      <router-link to="/contact">Contact</router-link>
      <div class="copyright">
        <p>&copy; {{ currentYear }} Coffee Syndicate</p>
        <a href="https://instagram.com/coffeesyn" target="_blank" rel="noopener noreferrer" class="social-link">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
      </div>
    </nav>
    <main class="main-content">
      <div class="scroll-container">
        <div class="content-inner">
          <router-view></router-view>
        </div>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style>
:root {
  --prussian-blue: #002b49ff;
  --french-gray: rgb(58, 68, 73);
  --tawny: #d15e14ff;
  --white: #ffffffff;
  --bittersweet-shimmer: rgb(192, 18, 18);
  --gutter: 40px;
}

@media (min-width: 1600px) {
  :root {
    --gutter: 60px;
  }
}

@media (min-width: 2000px) {
  :root {
    --gutter: 80px;
  }
}

@font-face {
  font-family: 'Manufaktur';
  src: url('@/assets/fonts/Manufaktur-Expanded-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Prompt';
  src: url('@/assets/fonts/Prompt-Medium.woff') format('woff');
  font-weight: 500;  /* Medium weight is typically 500 */
  font-style: normal;
}

#app {
  font-family: 'Prompt', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--prussian-blue);
  margin: 0;
  height: 100vh;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden; /* Prevent body scroll on mobile */
  overflow-x: hidden; /* Prevent horizontal scroll */
  max-width: 100vw; /* Prevent horizontal overflow */
  font-size: 16px;
}

/* Scale up content on larger screens */
@media (min-width: 1600px) {
  html {
    font-size: 18px;
  }
}

@media (min-width: 2000px) {
  html {
    font-size: 20px;
  }
}

@media (min-width: 2400px) {
  html {
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  html, body {
    overflow: hidden; /* Ensure no body scroll on mobile */
    overflow-x: hidden; /* Prevent horizontal scroll on mobile */
    max-width: 100vw; /* Prevent horizontal overflow on mobile */
  }
}

h1 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  margin-top: -1rem;
  font-family: 'Manufaktur', sans-serif;
  color: var(--tawny);
}

h2 {
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  color: var(--prussian-blue);
  font-family: 'Manufaktur', sans-serif;
}

h3 {
  margin-bottom: 1rem;
  color: var(--prussian-blue);
  font-family: 'Manufaktur', sans-serif;
}

p {
  line-height: 1.6;
  color: var(--french-gray);
  font-family: 'Prompt', sans-serif;
}

.layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 25%;
  background-color: var(--prussian-blue);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 8px solid var(--prussian-blue);
  border-right: none;
}

.main-content {
  width: 75%;
  padding: 0;
  position: relative;
  z-index: 2;
  background-color: var(--white);
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.content-inner {
  max-width: 1200px;
  padding-left: var(--gutter);
  padding-right: var(--gutter);
}

@media (min-width: 1600px) {
  .content-inner {
    max-width: 1400px;
  }
}

@media (min-width: 2000px) {
  .content-inner {
    max-width: 1700px;
  }
}

@media (min-width: 2400px) {
  .content-inner {
    max-width: 2000px;
  }
}

/* Custom scrollbar styling */
.scroll-container::-webkit-scrollbar {
  width: 12px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 6px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.sidebar .router-link-active,
.sidebar a {
  font-family: 'Manufaktur', sans-serif;
  text-decoration: none;
  color: var(--white);
  padding: 10px;
  font-size: 24px;
  text-align: left;
  display: block;
  transition: transform 0.075s ease, color 0.1s ease;
  position: relative;
}

.sidebar a:hover {
  color: var(--tawny);
}

/* Modify the existing selectors to exclude the first link (logo) */
.sidebar a:not(:first-child)::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: -10px;
  width: 0;
  height: 4px;
  background-color: var(--white);
  transition: width 0.075s ease;
}

.sidebar a:not(:first-child):hover::before,
.sidebar a:not(:first-child).router-link-active::before {
  width: calc(100% + 20px);
  z-index: 1;
}

.sidebar a:not(:first-child):hover:not(.router-link-active) {
  transform: translateX(2px);
}

.sidebar a:not(:first-child).router-link-active {
  position: relative;
  transform: translateX(4px);
  width: calc(100% - 10px);
  z-index: 3;
  background-color: var(--prussian-blue);
  clip-path: polygon(0% 0%, 100% 0%, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0% 100%);
  color: var(--tawny);
}

.sidebar a:not(:first-child).router-link-active::after {
  content: '*';
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* Remove old hover and active styles */
.sidebar a:hover {
  border-bottom: none;
  padding: 10px;
}

.sidebar .router-link-active {
  background-color: transparent;
}

.sidebar .router-link-active:hover {
  background-color: transparent;
  border-bottom: none;
  padding: 10px;
}

.logo {
  width: 20%;
  margin-left: 10px;
  margin-bottom: 30px;
  transition: all 0.075s ease;
}


.logo:hover {
  color: var(--tawny);
}

.copyright {
  margin-top: auto;
  padding: 20px 10px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}

.copyright p {
  margin: 5px 0;
  font-family: 'Prompt', sans-serif;
  font-size: 12px;
  color: var(--white);
  line-height: 1.4;
}

.copyright .social-link {
  display: flex !important;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0;
  font-family: 'Prompt', sans-serif;
  font-size: 12px;
  color: var(--white);
  text-decoration: none;
  transition: color 0.1s ease;
  border-bottom: none;
  padding: 1rem !important;
  transform: none !important;
  position: static !important;
  flex-shrink: 0;
}

.copyright .social-link:hover {
  color: var(--tawny);
  text-decoration: none;
  border-bottom: none;
  transform: none !important;
  background-color: transparent !important;
}

.copyright .social-link::before,
.copyright .social-link::after {
  display: none !important;
}

/* Form Elements Styling */
input, textarea, select {
  font-family: 'Prompt', sans-serif;
  font-size: 16px;
  padding: 12px;
  border: 2px solid var(--prussian-blue);
  background-color: var(--white);
  width: 100%;
  box-sizing: border-box;
  transition: all 0.075s ease;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--prussian-blue);
  box-shadow: 0 0 0 2px var(--prussian-blue);
}

input[type="checkbox"]:focus, input[type="radio"]:focus {
  outline: none;
  border-color: initial;
  box-shadow: none;
}

/* Button Styling */
.btn {
  font-family: 'Manufaktur', sans-serif;
  font-size: 18px;
  padding: 12px 24px;
  background-color: var(--prussian-blue);
  color: var(--white);
  border: 2px solid var(--prussian-blue);
  cursor: pointer;
  transition: all 0.075s ease;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 43, 73, 0.2);
}

.btn:active {
  transform: translateY(0);
}

.btn:disabled {
  background-color: white;
  color: var(--french-gray);
  border: 2px solid var(--french-gray);
  cursor: not-allowed;
}

.btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Button Variants */
.btn-outline {
  background-color: var(--white);
  color: var(--prussian-blue);
}

.btn-outline:hover {
  background-color: var(--prussian-blue);
  color: var(--white);
}

/* Form Layout Utilities */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-family: 'Prompt', sans-serif;
  font-size: 16px;
  margin-bottom: 8px;
  text-align: left;
}

/* Error States */
.input-error {
  border-color: var(--bittersweet-shimmer);
}

.error-message {
  color: var(--bittersweet-shimmer);
  font-size: 14px;
  margin-top: 4px;
  text-align: left;
}

.header-img {
  max-width: 400px;
  width: 50%;
  float: left;
}

/* Mobile Responsive Styles - includes landscape phones */
@media (max-width: 768px), (max-height: 500px) {
  .layout {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    max-width: 100vw;
    height: 50px;
    min-height: 50px;
    display: grid !important;
    grid-template-columns: auto repeat(4, 1fr);
    align-items: center;
    padding: 0;
    border: 4px solid var(--prussian-blue);
    border-bottom: none;
    box-sizing: border-box;
    overflow: visible;
  }
  
  .sidebar .logo {
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 10px !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  .sidebar .logo svg {
    height: 30px;
    width: auto;
  }
  
  .sidebar a:not(.logo) {
    font-size: 12px !important;
    padding: 8px 2px 12px 2px !important;
    margin: 0 !important;
    white-space: nowrap !important;
    width: 100% !important;
    position: relative !important;
    text-align: center !important;
    background-color: transparent !important;
    border: none !important;
    clip-path: none !important;
    transform: none !important;
    box-sizing: border-box !important;
  }
  
  .sidebar a:not(.logo):hover,
  .sidebar a:not(.logo):active {
    width: 100% !important;
    transform: none !important;
    background-color: transparent !important;
    clip-path: none !important;
  }
  
  .sidebar a:not(.logo).router-link-active {
    width: 100% !important;
    color: var(--tawny) !important;
    background-color: var(--prussian-blue) !important;
    clip-path: none !important;
    transform: none !important;
    padding-bottom: 18px !important;
    margin-bottom: -6px !important;
    border-radius: 0 0 4px 4px !important;
  }
  
  .sidebar a:not(.logo)::before,
  .sidebar a:not(.logo)::after {
    display: none !important;
  }
  
  
  .sidebar .copyright {
    display: none;
  }
  
  .main-content {
    width: 100%;
    height: calc(100vh - 60px);
    overflow: hidden;
  }
  
  /* Ensure sidebar doesn't cause horizontal scroll */
  .layout {
    overflow-x: hidden;
    max-width: 100vw;
  }
  
  .main-content .scroll-container {
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  .main-content .content-inner {
    padding-left: 20px;
    padding-right: 20px;
    max-width: none;
  }
  
  .header-img {
    max-width: 300px;
    width: 80%;
    float: none;
    display: block;
    margin: 0 auto;
  }
}
</style>
